module.exports = __webpack_public_path__ + "assets/images/base_roads_phase3.bc7c7bf3de0b6b8a3705974d404ec962.svg";